import { Component, OnInit } from '@angular/core';
import { TypeInterventionService } from 'src/app/_services/maintenance/interventions/type-intervention.service';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifService } from 'src/app/_services/notif.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth/auth.service';


@Component({
  selector: 'app-type-intervention-update',
  templateUrl: './type-intervention-update.component.html',
  styleUrls: ['./type-intervention-update.component.scss']
})
export class TypeInterventionUpdateComponent implements OnInit {


  user:any;
  TypeInterventionForm: FormGroup;
  isLoading = false;
  isError = false;
  isSuccess = false;
  isSubmitted = false;
  typeInterventions:any;
  type_intervention_id:any;


  constructor(
    private TypeInterventionService: TypeInterventionService,
    private notifService: NotifService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.user = this.authService.getUser()
    this.initForm();
    this.type_intervention_id = +this.route.snapshot.paramMap.get("id");
    this.TypeInterventionService.find(this.type_intervention_id).then(
      data => {
        this.typeInterventions = data;
        this.initForm(true);
      }
    ).catch(
      error => {
        this.translate.get('TypeInterventions.'+error.error.code)
        .subscribe(val => this.notifService.danger(val));
      }
    )
  }

     //initialisation du formulaire
     initForm(withTypeIntervention = false) {
      if(withTypeIntervention){
        this.TypeInterventionForm = this.formBuilder.group(
          {
            name: [this.typeInterventions.nom, [Validators.required]],
            description: [this.typeInterventions.description],
          }
        );
        }
      else{
        this.TypeInterventionForm = this.formBuilder.group(
          {
            name: ["", [Validators.required]],
            description: [""],
          }
        );
      }

    }

  get form() {
    return this.TypeInterventionForm.controls;
  }

  onSubmit() {
    console.log('on submit');
    this.isSubmitted = true;
    this.isError = false;
    this.isSuccess = false;
    this.isLoading = false;

    if (this.TypeInterventionForm.invalid) {
      this.translate.get('TypeIntervention.SubmitError')
        .subscribe(val => this.notifService.danger(val));
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    formData.append('nom', ''+this.form.name.value);
    formData.append('description', ''+this.form.description.value);

      console.log(formData);
      this.TypeInterventionService.put(this.type_intervention_id, formData)
      .then(resp => {
        this.translate.get('TypeIntervention.SubmitSuccess')
        .subscribe(val => this.notifService.success(val));
        this.isSubmitted = false;
        this.TypeInterventionForm.reset();
        this.router.navigate(['/intervention-type/list'])

      })
      .catch(err => {
        console.log(err)
        this.translate.get('TypeIntervention.SubmitErrorTypeIntervention')
        .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }

 }
